<template>
  <div class="flex flex-col pl-8 pr-3 w-full h-full">
    <div class="flex flex-row items-center gap-3 mb-3">
      <button
        @click="setActiveSubMenu('Tool')"
        class="flex flex-row justify-center items-center w-4 h-4 bg-gray-400 rounded-md"
        title="Kembali ke menu tool">
        <i class="material-icons text-lg text-white">chevron_left</i>
      </button>
      <h1 class="flex flex-col">
        <span class="text-sm text-white mr-1 font-bold">Buat zona</span>
        <i class="text-xs text-white">(daftar zona yang telah ditambahkan)</i>
      </h1>
    </div>
    <div class="flex flex-row mb-3">
      <div class="flex flex-row justify-end items-center w-full">
        <button
          @click="setActiveSubMenu('ToolZoneNew')"
          class="flex flex-row justify-center items-center p-2 bg-green-500 rounded-md">
          <i class="material-icons text-xs text-white mr-1">add</i>
          <span class="text-xs text-white">Tambah Zona</span>
        </button>
      </div>
    </div>
    <div class="Scroll pr-3 pb-3 w-full h-full overflow-hidden">
      <div class="flex flex-col sm:flex-row sm:flex-wrap mb-3">
        <div
          v-for="(zone, index) in zones.data"
          :key="index"
          class="flex flex-col p-3 w-full bg-gray-400 rounded border border-gray-500">
          <span class="text-sm text-white">{{ zone.title }}</span>
          <span class="text-xs text-gray-100">{{ zone.description }}</span>
          <div class="flex gap-1 justify-end items-center">
            <button
              @click="deleteZone(zone)"
              class="flex justify-center items-center w-5 h-5 bg-gray-100 rounded-full text-red-500"
              type="button"
              title="Hapus Zona">
              <i class="material-icons text-sm">delete</i>
            </button>
          </div>
        </div>
      </div>
      <Pagination
        class="justify-end items-end"
        :offset="zones.offset"
        :limit="zones.limit"
        :total="zones.total"
        :handler="changePage" />
    <PopupConfirm ref="PopupZone" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Pagination from './Pagination.vue'
import PopupConfirm from './PopupConfirm.vue'

export default {
  name: 'ToolZones',
  data: () => ({
    deletedZone: null
  }),
  computed: {
    ...mapGetters([
      'zones'
    ])
  },
  components: {
    Pagination,
    PopupConfirm
  },
  methods: {
    ...mapActions([
      'toLoadZones',
      'toDeleteZone'
    ]),
    ...mapMutations(['setActiveSubMenu']),
    deleteZone: function (zone) {
      this.deletedZone = zone

      this.$refs.PopupZone.show(
        `Apakah anda yakin ingin menghapus zona "${zone.title}"?`,
        { handler: this.confirmDeleteZone }
      )
    },
    confirmDeleteZone: async function () {
      await this.toDeleteZone(this.deletedZone.id)
      await this.toLoadZones()
    },
    changePage: async function (page) {
      await this.toLoadZones({
        offset: page.offset,
        limit: page.limit
      })
    }
  },
  mounted: async function () {
    await this.toLoadZones()
  }
}
</script>
